export default {
  // finance-category-meta.tsx
  Title: "Titre",
  Type: "Type",
  Description: "Description",
  Shop: "Boutique",
  Actions: "Actions",

  // finance-category-form.tsx
  "Select type": "Sélectionner le type",
  "Select a shop": "Sélectionner une boutique",
  "Select OHADA code": "Sélectionner un code OHADA",

  // select-finance-category.tsx
  "Finance Category": "Catégorie financière",
  "Search by title, type or shop": "Rechercher par titre, type ou boutique",
  "Edit Selection": "Modifier la sélection",
  "No categories found": "Aucune catégorie trouvée",

  // create-finance-category-modal.tsx
  "Create a new category": "Créer une nouvelle catégorie",

  // edit-finance-category-modal.tsx
  "Edit Category": "Modifier la catégorie",

  // view-finance-category-modal.tsx
  "Category Details": "Détails de la catégorie",
  "OHADA Code": "Code OHADA",

  // delete-finance-category-modal.tsx
  "Do you really want to delete this category?": "Voulez-vous vraiment supprimer cette catégorie ?",
  "Warning: This action is irreversible.": "Attention : cette action est irréversible.",
  "Confirm Deletion": "Confirmer la suppression",
  Cancel: "Annuler",

  // finance-category-list-block.tsx
  "Finance Categories": "Catégories financières",
  "Add category": "Ajouter une catégorie",

  // Types
  income: "Revenu",
  expense: "Dépense",

  Submit: "Soumettre",
};
